import type { Dispatch, SetStateAction } from 'react'

import type {
	ISelectedPlatform,
	TPlatformHeaderKind,
	TPlatformValue
} from '@/types/uploadForm.interface'

import {
	createResetHeaderStatePatch,
	getLinkedPlatform
} from './platformHeaderState'

export const resetPlatformHeaderState = ({
	selectedPlatform,
	setSelectedPlatformList,
	state = 'idle'
}: {
	selectedPlatform: TPlatformValue | null
	setSelectedPlatformList: Dispatch<SetStateAction<ISelectedPlatform[]>>
	state?: TPlatformHeaderKind
}) => {
	if (!selectedPlatform) return

	const linked = getLinkedPlatform(selectedPlatform)
	const targets = linked ? [selectedPlatform, linked] : [selectedPlatform]

	setSelectedPlatformList(prev =>
		prev.map(plat =>
			targets.includes(plat.value)
				? { ...plat, ...createResetHeaderStatePatch(state) }
				: plat
		)
	)
}
